// extracted by mini-css-extract-plugin
export default {"fieldGrid":"RecipeNutritionUpdate_fieldGrid__DVnSM","addBtn":"RecipeNutritionUpdate_addBtn__27Wa-","modalScrollContent":"RecipeNutritionUpdate_modalScrollContent__2rOiZ"};